import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface CancelIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CancelIcon = ({ className, ...props }: CancelIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9_352)">
      <path
        d="M5.65741 18.6574L12.3148 12M18.9722 5.34259L12.3148 12M12.3148 12L5.65741 5.34259M12.3148 12L18.9722 18.6574"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_352">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CancelIcon;
